import { render, staticRenderFns } from "./ModuleBrandEditForm.vue?vue&type=template&id=700cbf15&"
import script from "./ModuleBrandEditForm.vue?vue&type=script&lang=js&"
export * from "./ModuleBrandEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports